

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { CreateResult } from '../models/create-result';
import { ParticipantViewModel } from '../models/participant-view-model';
import { ParticipantService } from '../services/participant.service';
import { AuthenticationService } from '../services/authentication.service';
import { UserDataStoreService } from '../services/user-data-store.service';
import { PermissionEnum } from '../services/guards/permissions';
import { CardSetsViewModel } from '../models/card-set';
import { MerchantService } from '../services/merchant.service';
import { CustomTagParticipantLinkViewModel } from '../models/card-set-participant-link';
import {CardAcceptorConfigViewModel} from '../models/card-acceptor-config-view-model';
import {ConfirmationDialogComponent} from '../partials/confirmation-dialog/confirmation-dialog.component';
import {CardAcceptorConfigService} from '../services/card-acceptor-config.service';
import {CardSetService} from "../services/card-set.service";

@Component({
  selector: 'app-card-set-mapping-view',
  templateUrl: './card-set-mapping-view.component.html',
  styleUrls: ['./card-set-mapping-view.component.scss']
})
export class CardSetMappingViewComponent implements OnInit {

  public cardSets: Select2OptionData[];
  public allsinkNodes: Select2OptionData[];
  public mapCustomCardSets: Select2OptionData[];

  public participant: ParticipantViewModel;
  public cardSetsByParticipant: CustomTagParticipantLinkViewModel[] = [];

  public createResult: CreateResult;
  public canEdit: boolean;
  errorMessage: string;
  error: boolean;
  public selectedCardSet: string;

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  constructor(private _modalService: NgbModal,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _cardSetService: CardSetService,
    private _participantService: ParticipantService,
    private _merchantService: MerchantService,
    private _authenticationService: AuthenticationService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _route: ActivatedRoute) {
    this._route.params.subscribe(async params => {
      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
      await this.initParticipant(params.id);
      this.cardSets = (await this._merchantService.GetCardSets()).map((x) => {
        return { id: x.cardSet, text: x.cardSet }
      });
      this.cardSetsByParticipant = await this._cardSetService.GetCardSetsByParticipantId(this.participant.id);
      this.filterCardSets();
    });
  }

  public async ngOnInit(): Promise<void> {

  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public filterCardSets(): void {
    const filteredItems = this.cardSets.filter((item) => {
      if (this.cardSetsByParticipant != null) {
        const index = this.cardSetsByParticipant.findIndex(x => x.cardSet.toString() === item.text);
        if (index > -1) {
          return false;
        }
      }
      return true;
    });
    this.mapCustomCardSets = filteredItems;
  }

  public async save(): Promise<void> {
    debugger;
    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {

      this.createResult = await this._cardSetService.DeleteCardSetsByParticipantId(this.participant.id);

      if (this.createResult.success) {
        this.createResult = await this._cardSetService.UpdateCardSets(this.cardSetsByParticipant);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, 'Success');
        } else {
          this._toastService.error(this.createResult.message, 'Error');
        }
      }
      else {
        this._toastService.error(this.createResult.message, 'Error');
      }
    }
  }


  public addSinkNodeMappedFields(): void {

    let cardSet: string = this.selectedCardSet;
    if (cardSet == null) {
      alert('Select a Card set');
    }
    else {
      this.cardSetsByParticipant.push({
        cardSet: this.selectedCardSet,
        participantId: this.participant.id,
      });
      this.filterCardSets();

    }
  }

  public deleteMappedField(cardset: string): void {
    const index = this.cardSetsByParticipant.findIndex(x => x.cardSet == cardset);

    if (index > -1) {
      this.cardSetsByParticipant.splice(index, 1);
    }
    this.filterCardSets();
  }

  public async determineDeleteDialog(cardSet: string) {
    const cardSets = await this._merchantService.CountCardSets({cardSet: cardSet});
    if (cardSets > 0) {
      await this.openUsedDeleteFailureConfirmationDialog(cardSets);
      return;
    }

    var cardAcceptors = await this._cardAcceptorConfigService.GetCardAcceptorsByCardSet(cardSet, this.participant.id);
    if (!!cardAcceptors && cardAcceptors.length === 0) {
      await this.openDeleteConfirmationDialog(cardSet);
    }
  }

  public async openDeleteConfirmationDialog(cardset: string) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Card Set Removal'
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected card set?'

    const result = await dialogRef.result;
    if (result) {
      await this.deleteMappedField(cardset);
    }
  }

  public async openUsedDeleteFailureConfirmationDialog(merchantCount: number) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = 'OK'
    dialogRef.componentInstance.title = 'Card Set Cannot Be Removed'
    dialogRef.componentInstance.message = `The card set is currently in use by ${merchantCount} merchants and cannot be deleted.`
  }
}

